import { ContentPostContentDownloadDto, MediaUploadDto } from 'collaboration-service';
import UploadSelection from 'components/UploadSelection';
import { Button, Input, Label, Tooltip } from 'imaginarity-react-ui';
import * as React from 'react';
import { useCheckWhereIAm } from 'services/Helpers/RoutingHelper';
import { useImgI18N } from 'services/ImgI18N';
import { EPLContainer, EPLEditContainer, EPLLabelContainer } from '../EditPartLabelAndEditor';
import AssetMediaSelection from './AssetMediaSelection';
import ContentMediaSelection from './ContentMediaSelection';
import { EditorsSC as T } from './EditorsSC';
import MissingInputHint from 'components/MissingInput/MissingInputHint';
import { MissingTexts } from '../TypeImplementations/PostEdit';


interface EditLanguageContentProps {
    content?: ContentPostContentDownloadDto;
    useContentChanged: (value: boolean) => void;
    setContent: (file: File | undefined, media: MediaUploadDto) => void;
    reset: () => void;
    selected: boolean,
}



const EditLanguageContent = (p: EditLanguageContentProps) => {
    const { content, setContent, reset, selected } = p;
    const { t } = useImgI18N("admin");
    // const [useContentX, setUseContentX] = React.useState(content ? content.useContent : undefined);
    const check = useCheckWhereIAm();
    const isPodcastUpload = check("admin_podcast_upload");

    // const change = (useContent: boolean) => {
    //     setUseContentX(!useContentX)
    //     p.useContentChanged(useContent);
    // }

    //console.log('content => ', content);
    /*    const forwardFiles = (file: File | undefined, media: MediaUploadDto) => {
            console.log("here we go!");
            setContent(file, media);
        }*/

    // const isContent = content && content.useContent && content.content ? true : false;
    return (
        <EPLContainer>
            <EPLLabelContainer style={{ minHeight: 110 }}>

                <T.ContentTypeContainer hoverable={false} style={{ marginTop: 2 }}>
                    <div><Label content={t("podcast file")} icon="mic on" /></div>
                    {content?.useContent && !content.content.fileName &&
                        <MissingInputHint tooltipErrorText={t(MissingTexts.podcastsMissing)} />
                    }
                </T.ContentTypeContainer>

                {/*<T.ContentTypeContainer onClick={!isContent ? () => change(false) : undefined} hoverable={!isContent} style={{ marginTop: 2 }}>
                    <div><Label content={t("document")} icon="file" bold={isContent} /></div>
                    <div><Icon name={isContent ? "check square" : "square"} style={{ float: "right" }} /></div>
                </T.ContentTypeContainer>
                 <T.ContentTypeContainer onClick={isContent ? () => change(true) : undefined} hoverable={isContent}>
                    <div><Label content={t("link")} icon="link" bold={!isContent} /></div>
                    <div><Icon name={isContent ? "square" : "check square"} style={{ float: "right" }} /></div>
                </T.ContentTypeContainer> */}


                {/* <Checkbox
                    label={content?.useContent ? t("document") : t("link")}
                    selected={content?.useContent ?? false}
                    onClick={useContentChanged}
                /> */}
            </EPLLabelContainer>
            <EPLEditContainer bordered style={{ background: "#fff" }}>
                {content?.useContent && content.content ?
                    <UploadSelection
                        media={content.content as MediaUploadDto}
                        onFileSelected={setContent}
                        icon="upload cloud"
                        buttonText="select file"
                        kind={selected ? 'cancelButton' : 'primary'}
                    // tooltip={{ tooltipText: t("select file"), offsetX: -35, position: "top", noMargin: true }}
                    >
                        {p => {
                            //const np: typeof p = { ...p, fileSelected: (f, m) => { forwardFiles(f, m); p.fileSelected(f, m); } }
                            return (
                                <>
                                    {!isPodcastUpload &&
                                        <>
                                            <ContentMediaSelection
                                                selectProps={p}
                                                lng={content.lng}
                                            />
                                            <AssetMediaSelection selectProps={p} />
                                            <Tooltip tooltipText={t("reset value")} position="top" noMargin offsetX={-35}>
                                                <Button {...p.buttonProps} icon="undo" onClick={reset} />
                                            </Tooltip>
                                        </>
                                    }
                                </>)
                        }}
                    </UploadSelection>
                    :
                    <>
                        <div style={{ marginBottom: 10 }}>make sure you enter the link with https://</div>
                        <Input placeHolder='https://yourLink' />
                    </>
                }
            </EPLEditContainer>
        </EPLContainer >
    );
}
export default EditLanguageContent;